import { createAction } from '@reduxjs/toolkit';
import { UserTeamAccess } from '../types';

export const userTeamAccessVerify = createAction('userTeamAccess/verify');
export const userTeamAccessVerifyResolved = createAction<UserTeamAccess>(
	'userTeamAccess/resolved',
);
export const userTeamAccessVerifyRejected = createAction(
	'userTeamAccess/rejected',
);
